import { ListItemButton } from "@mui/material"
import type { FC } from "react"

import type { SalesProduct } from "../../types"
import { resultItemSelectedSx } from "../styles"

import { ProductCard } from "./ProductCard"

interface ProductResultItemProps {
  product: SalesProduct
  selected: boolean
  onSelect: (product: SalesProduct) => void
}

export const ProductResultItem: FC<ProductResultItemProps> = ({ product, selected, onSelect }) => (
  <ListItemButton
    selected={selected}
    onClick={() => onSelect(product)}
    className='p-4'
    sx={resultItemSelectedSx}
    data-testid={`sales.product-result-item.${product.productId}`}
  >
    <ProductCard product={product} />
  </ListItemButton>
)
